/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from '../../components/buttons/Buttons';
import PreformattedText from '../../components/PreformattedText';
import { ScrollAwareContext, ScrollAwareScroller } from '../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../components/appNav/AppHeaderScrollable';
import ContentFrame from '../../applicationFrame/ContentFrame';
import AppNavTopLevel from '../../components/appNav/AppNavTopLevel';

import CustomerService from '../../../utilities/CustomerService';
import { ConnectedGrayPrivacyCard } from '../../components/card/PrivacyCard';
import Card, { CardSection } from '../../components/card/Card';
import { PolicyName } from '../../../models/PolicyModel';
import ContentWrapper from '../../components/ContentWrapper';

class ContactUs extends React.Component {

  constructor(props) {
    super(props);

    this.showIntercomDialog = this.showIntercomDialog.bind(this);
  }

  componentWillUnmount() {
    CustomerService.hide();
  }

  showIntercomDialog() {
    CustomerService.show();
  }

  render() {
    return (
      <div>
        <ScrollAwareContext>
          <AppNavTopLevel hasDropShadow />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableText id="contact.title.text" />

              <ContentWrapper>
                <ConnectedGrayPrivacyCard
                  name={PolicyName.CONTACT_US}
                  subTitle="privacy.privacyBlock.contactUs.teaser"
                />

                <Card>
                  <CardSection className="font-body">
                    <PreformattedText text="contact.intro.message.text" textClassName=" " />

                    <div style={{ marginTop: 24 }}>
                      <FormattedMessage id="contact.end.message.text" />
                    </div>
                  </CardSection>
                </Card>

                <FormattedMessage id="contact.emailAlias.backpack.help">
                    {
                      (email) => (
                        <Button action="profile" onClick={() => { location.href=`mailto:${email}` }} size="wide" style={{ marginTop: 0 }}>
                          <FormattedMessage id="contact.email.field.label" />
                        </Button>
                      )
                    }
                </FormattedMessage>

              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
ContactUs.propTypes = {
  goBack: PropTypes.func,
};


export default ContactUs;
